// extracted by mini-css-extract-plugin
export default {"file_content":"drag-and-drop-file_file_content__Zov-3","header_text":"drag-and-drop-file_header_text__CcilG"};